<template>
    <a-drawer :title="titleName" width="1200px" placement="right" :closable="true" :visible="visible" @close="handleCancelEvent">
        <div class="flex" style="margin-bottom: 50px">
            <div class="flex-item">
                <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol" class="mt20" ref="formRef">
                    <a-form-item :label="$t('submission.sms_title' /*标题*/)">
                        <a-input v-decorator="['title']" :placeholder="$t('submission.sms_enter_title' /*请输入标题*/)" />
                    </a-form-item>

                    <a-form-item :label="$t('submission.sms_template_content' /*模板内容*/)">
                        <a-collapse>
                            <a-collapse-panel v-for="(item, index) in tagsObj" :key="index" :header="index" :forceRender="true">
                                <a-row :gutter="[15, 15]" type="flex" style="flex-warp: warp">
                                    <a-col v-for="(it, ind) in item" :key="ind" @click="handleAddtagsEvent(it)">
                                        <a-button type="link">{{ ind }}</a-button>
                                    </a-col>
                                </a-row>
                            </a-collapse-panel>
                        </a-collapse>
                        <a-textarea class="mt10" v-decorator="['content']" style="height: 100px"></a-textarea>
                        <div slot="extra" class="fs12 error-color">{{ $t('submission.sms_max_length_tip' /*一次发放短信内容的最长字符数不超过500字符*/) }}</div>
                    </a-form-item>
                    <a-form-item :label="$t('submission.sms_signature' /*短信签名*/)">
                        <a-select v-decorator="['js_write_title']">
                            <a-select-option :value="$t('submission.sms_signature_option1' /*会务通*/)">{{ $t('submission.sms_signature_option1' /*会务通*/) }}</a-select-option>
                            <a-select-option :value="$t('submission.sms_signature_option2' /*会务组*/)">{{ $t('submission.sms_signature_option2' /*会务组*/) }}</a-select-option>
                        </a-select>
                        <div slot="extra" class="fs12 error-color">
                            {{ $t('submission.sms_signature_tip' /*签名通知：运营商已开启全局白名单管控功能，现提供 【会务通】【会务组】，如填写自定义签名，请直接写短信内容中。*/) }}
                        </div>
                    </a-form-item>
                    <a-form-item :label="$t('submission.sms_is_enabled' /*是否启用*/)">
                        <a-radio-group v-decorator="['status', { initialValue: '1' }]">
                            <a-radio value="1">{{ $t('submission.sms_yes' /*是*/) }}</a-radio>
                            <a-radio value="0">{{ $t('submission.sms_no' /*否*/) }}</a-radio>
                        </a-radio-group>
                        <div slot="extra" class="fs12 error-color">
                            <p>{{ $t('submission.sms_enabled_tip1' /*注意：如果短信内容包含标签，则短信内容字符以替换标签后的字符数为准！*/) }}</p>
                            <p>
                                {{
                                    $t(
                                        'submission.sms_enabled_tip2' /*短信计费规则： 70字以内计费一条，超过70字,67个字计费一条，短信最多可以支持500字。 按字符计算，1个英文字母，1个数字，1个标点，1个空格，1个汉字，都算1个字。 长短信整条短信按67的倍数扣费。*/
                                    )
                                }}
                            </p>
                        </div>
                    </a-form-item>
                </a-form>
            </div>
            <div style="width: 30%" class="phone-bg">
                <div class="text-content">
                    {{ form.getFieldValue('content') }}
                </div>
            </div>
        </div>

        <div
            class="t-r"
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '50px',
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1
            }"
        >
            <a-button type="default" @click="handleCancelEvent">{{ $t('submission.sms_close' /*关闭*/) }}</a-button>
            <a-button class="ml10" type="primary" @click="handleSubmitEvent">{{ $t('submission.sms_submit' /*提交*/) }}</a-button>
        </div>
    </a-drawer>
</template>

<script>
const fields = ['title', 'js_write_title', 'content', 'status'];
import pick from 'lodash.pick';
export default {
    name: 'EditSms',
    components: {},
    data() {
        return {
            visible: false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 }
            },
            form: this.$form.createForm(this),
            tagsObj: {},
            template_id: '',
            titleName: ''
        };
    },
    computed: {},
    methods: {
        show(template_type, titleName) {
            this.visible = true;
            this.titleName = titleName;
            // 防止表单未注册
            fields.forEach(v => {
                this.form.getFieldDecorator(v);
            });
            let data = {
                type: 1, // 1短信 2邮件
                template_type, // 设置录取通知函邮件（中英文模版类型值 8），设置审核通过类型值邮件：19），设置审核驳回模版类型值：邮件：20
                language: 1
            };
            this.getAbstractTemplateInfo(data);
            this.getAbstractTemplateTags();
        },
        handleCancelEvent() {
            this.visible = false;
        },
        handleSubmitEvent() {
            this.form.validateFields((error, values) => {
                let data = {
                    type: 1,
                    template_id: this.template_id,
                    language: 1,
                    ...values
                };
                this.$request.post({ url: 'setAbstractTemplate', data: data }).then(res => {
                    this.$message.success(this.$t('submission.sms_submit_success' /*提交成功*/));
                });
            });
        },
        // 插入标签
        handleAddtagsEvent(item) {
            let content = this.form.getFieldValue('content');
            this.form.setFieldsValue({
                content: content + item
            });
        },
        getAbstractTemplateTags() {
            this.$request.get({ url: 'getAbstractTemplateTags', data: { type: 2 } }).then(res => {
                const { data } = res;
                this.tagsObj = data;
            });
        },
        getAbstractTemplateInfo(data) {
            this.$request.get({ url: 'getAbstractTemplateInfo', data }).then(res => {
                const { data } = res;
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(data, fields));
                    this.template_id = data.id;
                });
            });
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
.preview-box {
    padding: 30px;
    background-color: #f9f9f9;
}
.phone-bg {
    background: url('https://files.sciconf.cn/asset/images/sms.jpeg') no-repeat;
    background-size: 80% auto;
    background-position-x: 50%;
    background-position-y: 0;
    position: relative;
    .text-content {
        position: absolute;
        right: 18%;
        top: 30%;
        color: #ffffff;
        background: rgb(3, 217, 74);
        width: 50%;
        border-radius: 10px;
        padding: 10px;
        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            right: -8px;
            border-width: 8px;
            border-style: solid;
            border-color: transparent transparent rgb(3, 217, 74) transparent;
            border-radius: 0 13px;
        }
    }
}
.message-box {
    position: relative;
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    margin-top: 20px;
}
</style>
